import { render } from "./OrderDetailsDraft.vue?vue&type=template&id=28fd2f4e&scoped=true"
import script from "./OrderDetailsDraft.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDraft.vue?vue&type=script&lang=js"

import "./OrderDetailsDraft.vue?vue&type=style&index=0&id=28fd2f4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fd2f4e"]])

export default __exports__